import { Injectable } from '@angular/core';

import * as Mustache from 'mustache';
import { LocalizationService } from './localization.service';
import { PGUtilities } from '../utilities/pg-utilities';

/** Lightweight Mustache evaluator used by pg-select resource options. */
@Injectable({
    providedIn: 'root'
})
export class SemanticsEvaluatorService {
    constructor(private localizationService:LocalizationService) {}

    evaluateSemanticTemplate(template:string, data:any) {
            data = JSON.parse(JSON.stringify(data))

            if(data.translations != null) {
                let _translation = null;

                for(let _item of data.translations) {
                    if(_item.language == this.localizationService.currentLanguage) {
                        _translation = _item;
                        break;
                    }
                }

                if(_translation == null) {
                    for(let _item of data.translations) {
                        if(_item.language == this.localizationService.currentLanguage.replace(/_.*$/, '').toUpperCase()) {
                            _translation = _item;
                            break;
                        }
                    }
                }

                if(_translation != null) {
                    _translation = PGUtilities.cleanTranslation(_translation)

                     for(let i in _translation) {
                        if(_translation[i] != null && _translation[i] != '') {
                            data[i] = _translation[i];
                        }
                    }
                }
            }

            delete data.translations;

        return Mustache.render(template, data);
    }
}
